/*
 * Scroll reveal for .gh-home-reveal on the home template only.
 * Adds body.gh-home-anim-ready so CSS can hide off-screen items without breaking no-JS.
 */

export default function landingMotion() {
    if (!document.body.classList.contains('home-template')) {
        return;
    }

    const nodes = document.querySelectorAll('.gh-home-reveal');
    if (!nodes.length) {
        return;
    }

    const revealAll = () => {
        nodes.forEach((el) => el.classList.add('is-visible'));
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealAll();
        return;
    }

    if (!('IntersectionObserver' in window)) {
        revealAll();
        return;
    }

    /* App features: reveal immediately on load (no IntersectionObserver). */
    document.querySelector('.gh-home-features.gh-home-reveal')?.classList.add('is-visible');

    document.body.classList.add('gh-home-anim-ready');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            rootMargin: '0px 0px -5% 0px',
            threshold: 0.08,
        }
    );

    document.querySelectorAll('.gh-home-reveal:not(.is-visible)').forEach((el) => observer.observe(el));
}
